import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SessionProvider, useSession } from "@/context/SessionContext";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import SsoLaunch from "@/pages/SsoLaunch";
import Websites from "@/pages/Websites";
import SiteDetail from "@/pages/SiteDetail";
import PageReview from "@/pages/PageReview";
import Glossary from "@/pages/Glossary";
import AgencyOverview from "@/pages/AgencyOverview";

const Protected = ({ children }) => {
  const { session, loading, error } = useSession();
  if (loading) return <div className="p-10 font-mono text-sm text-slate-500" data-testid="app-loading">Checking your Morr session…</div>;
  if (error) return <div className="p-10 text-sm text-red-700" data-testid="app-error">{error}</div>;
  if (!session) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
};

function App() {
  return (
    <div className="App">
      <SessionProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/sso/launch" element={<SsoLaunch />} />
            <Route path="/" element={<Protected><Websites /></Protected>} />
            <Route path="/sites/:siteId" element={<Protected><SiteDetail /></Protected>} />
            <Route path="/pages/:pageId" element={<Protected><PageReview /></Protected>} />
            <Route path="/glossary" element={<Protected><Glossary /></Protected>} />
            <Route path="/clients" element={<Protected><AgencyOverview /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </SessionProvider>
    </div>
  );
}

export default App;
